import { Grid, useMediaQuery } from "@mui/material";
import { apiClient } from "api/apiClient";
import axios from "axios";
import _ from "lodash";
import TestDriveForm from "Pages/TestDrive/TestDriveForm/TestDriveForm";
import TestDriveHero from "Pages/TestDrive/TestDriveHero";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const TestDrive = () => {
  const small = useMediaQuery("(max-width: 600px)");
  const history = useHistory();
  const [bannerData, setBannerData] = useState([]);
  const [thankYouBanner, setThankYouBanner] = useState([]);
  const [isBooked, setIsBooked] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({});
  const { t } = useTranslation();
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");



  const getStatus = (details) => {
    setBookingDetails(details);
    setIsBooked(true);
  };


  const handleSelectVehicle = (vehicle) => {
  setSelectedVehicle(vehicle)
  }


  useEffect(() => {
    // Fetch the data from the API
    axios
      .get("https://cms.eulermotors.com/api/test-drive-vehicles?populate=*")
      .then((response) => {
        // Assuming the data you need is in response.data.data
        setVehicles(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
      });
  }, []);

  useEffect(() => {
    apiClient.getTestDriveBanner().then((res) => {
      setBannerData(res.data[0]);
    });
    apiClient.getTestDriveThankYou().then((res) => {
      setThankYouBanner(res.data[0]);
    });
  }, []);



  useEffect(() => {
    if (isBooked) {
      window.scrollTo(0, 0);
      history.push({
        pathname: "/thank-you-test-drive",
        state: {
          booked: true,
          bookingDetails,
          bannerData: thankYouBanner,
          small,
        },
      });
    }
  }, [isBooked]);
  return (
    <>
      {!_.isEmpty(bannerData) && (
        <Grid item xs={12}>
          <TestDriveHero bannerData={bannerData} small={small} />
        </Grid>
      )}

      <Grid item xs={12}>
        <div style={{ width: "90%", margin: "0 auto" }}>
          <h3 className="form_section_heading" style={{ paddingTop: "0px" }}>
            Select Vehicle
          </h3>
          <div
            className="mainveh"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {vehicles.map((vehicle, index) => (
              <div
              // value={vehicle.attributes.heading}
              onClick={() => handleSelectVehicle(vehicle.attributes.heading)}
              className={selectedVehicle=== vehicle.attributes.heading ? "active Veh ":"Veh "} key={index}>
                <img
                  src={vehicle.attributes.image.data.attributes.url}
                  alt={vehicle.attributes.name}
                />
                <p style={{ fontWeight: "700", fontSize: "32px" }}>
                  {vehicle.attributes.heading}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Grid>

      <Grid item xs={12}>
        <TestDriveForm
          getStatus={getStatus}
          small={small}
          bannerData={thankYouBanner}
          selectedVehicle={selectedVehicle}
        />
      </Grid>
      <Helmet>
        <title>Book a Test Ride - Euler Motors</title>
        <link rel="canonical" href="https://www.eulermotors.com/en/text-ride" />
        <link rel="canonical" href="https://www.eulermotors.com/hi/text-ride" />
        <link rel="canonical" href="https://www.eulermotors.com/ta/text-ride" />
        <link rel="canonical" href="https://www.eulermotors.com/te/text-ride" />
        <link rel="canonical" href="https://www.eulermotors.com/mr/text-ride" />
        <link rel="canonical" href="https://www.eulermotors.com/gu/text-ride" />
        <link rel="canonical" href="https://www.eulermotors.com/kn/text-ride" />
        <link rel="canonical" href="https://www.eulermotors.com/bn/text-ride" />
     
        <link rel="publisher" href="https://www.eulermotors.com/test-ride" />;
        <meta
          name="title"
          content={t("Book A Test Drive Online | Euler Motors")}
        />
        <meta
          name="description"
          content={t(
            "Schedule a test ride of Euler Motors's Electric 3-wheeler cargo loading vehicle and experience the power, and performance at the best price in the market."
          )}
        />
        ​
      </Helmet>
    </>
  );
};

export default TestDrive;
